import type { PatchMembersMeNicknameResponseDto } from './dto';
import type { PatchMembersMeNicknameParams } from './repository.types';

// PatchMembersMeNickname
export const mapPatchMembersMeNicknameModelToRequestDTO = (
  model: PatchMembersMeNicknameParams,
): PatchMembersMeNicknameParams => {
  return model;
};

export const mapPatchMembersMeNicknameResponseDTOToModel = (
  response: PatchMembersMeNicknameResponseDto,
) => {
  return response;
};
